import { BaseEntity } from "./BaseEntity";
import { InternshipSchedule } from "./InternshipSchedule";
import { User } from "./User";

export class StudentSkillComment extends BaseEntity {
    public internshipSchedule: string | InternshipSchedule = "";
    public student: string | User = "";
    public commentFinalReport: string | null = "";
    public commentPositivePoint: string | null = "";
    public commentAreasOfImprovement: string | null = "";
    public finalCommentFinalReport: string | null = "";
    public finalCommentPositivePoint: string | null = "";
    public finalCommentAreasOfImprovement: string | null = "";

    constructor(model: Partial<StudentSkillComment> = {}) {
        super(model?.id);
        Object.assign(this, model);
    }
}

export type PStudentSkillComment = Partial<StudentSkillComment>;
